var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReportUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5773 3.76282L11.8999 0.151062C11.8013 0.054245 11.6686 0 11.5303 0H2.23328C1.14838 0 0.265625 0.882614 0.265625 1.96765V16.0323C0.265625 17.1172 1.14824 18 2.23328 18H13.7674C14.8523 18 15.7351 17.1174 15.7351 16.0323V4.1391C15.7351 3.99751 15.6782 3.86197 15.5773 3.76282ZM12.0577 1.78445L13.9182 3.61176H12.2253C12.1329 3.61176 12.0577 3.5365 12.0577 3.44408V1.78445ZM13.7674 16.9453H2.23328C1.72997 16.9453 1.32031 16.5358 1.32031 16.0323V1.96765C1.32031 1.4642 1.72983 1.05469 2.23328 1.05469H11.0031V3.44408C11.0031 4.11809 11.5515 4.66644 12.2255 4.66644H14.6804V16.0323C14.6804 16.5358 14.2709 16.9453 13.7674 16.9453Z",
    fill: "#4B4B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6613 8.36719H4.22743C3.93616 8.36719 3.70009 8.60326 3.70009 8.89453C3.70009 9.18581 3.93616 9.42188 4.22743 9.42188H11.6613C11.9526 9.42188 12.1887 9.18581 12.1887 8.89453C12.1887 8.60326 11.9526 8.36719 11.6613 8.36719Z",
    fill: "#4B4B4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22743 11.5312H10.2889C10.5801 11.5312 10.8162 11.2952 10.8162 11.0039C10.8162 10.7126 10.5801 10.4766 10.2889 10.4766H4.22743C3.93616 10.4766 3.70009 10.7126 3.70009 11.0039C3.70009 11.2952 3.93616 11.5312 4.22743 11.5312Z",
    fill: "#4B4B4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0201 12.5859H4.22743C3.93616 12.5859 3.70009 12.822 3.70009 13.1133C3.70009 13.4046 3.93616 13.6406 4.22743 13.6406H11.0201C11.3113 13.6406 11.5475 13.4046 11.5475 13.1133C11.5475 12.822 11.3113 12.5859 11.0201 12.5859Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportUsers);
export default __webpack_public_path__ + "static/media/iconReportUsers.1b67ae7fa94f094b84cbec77ba11050a.svg";
export { ForwardRef as ReactComponent };